import axios from "axios";
import React, { useEffect, useState } from "react";

export default function Success() {
  const [data, setData] = useState(null);
  const url = new URL(window.location.href);

  const params = new URLSearchParams(url.search);

  // Access individual parameters
  const ks_id = params.get("kspay_id"); // "value1"
  const status = params.get("payment_status"); // "value1"
  const pay_id = params.get("provider_payment_id"); // "value1"

  useEffect(() => {
    getStatusById();
  }, []);
  const getStatusById = async () => {
    let headers = {
      // "x-signature":localStorage.getItem('sign'),
      authorization: `Bearer ${localStorage.getItem("access_token")}`,
    };

    try {
      let res = await axios.get(
        `${process.env.React_App_PAYMENT_URL}transaction/txnId/${ks_id}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      //   let res= await callApi(`transaction/txnId/${ks_id}`)
      // let res= await axios.get(`${process.env.REACT_APP_BASE_URL_QA}transaction/txnId/${param1}`,{headers})

      setData(res?.data?.result);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <div>
      Status : {status||data?.status||'Pending'} <br />
      Amount : Rs.{data?.amount}
      <br />
      transaction ID : {data?.id}
    </div>
  );
}
